import { ACTION_TYPES, CONTENT_TYPES, PAGES } from "utils/gtm/gtmEventsData"
import { Dropdown, Icon, Skeleton, Text } from "components/common"
import { useEffect, useMemo, useState } from "react"

import { IconText } from "components/custom"
import { Space } from "antd"
import { fireEvent } from "utils/gtm/gtmEventHandler"
import styles from "./index.module.less"
import theme from "utils/themeVars"
import { useSearchParams } from "react-router-dom"
import { t } from "i18next"

const CommonListDropdown = ({ multiple, list = [], onChange, defaults, disabled, loading, from }) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const queryObj = Object.fromEntries([...searchParams])
  const menuStyle = { overflowY: "auto", maxHeight: 240 }
  const [first, setFirst] = useState(defaults?.[0])
  const [second, setSecond] = useState(defaults?.[1])

  useEffect(() => {
    const preSelectedList = queryObj?.compare?.split("-vs-")
    if (defaults && preSelectedList?.length > 0) {
      setFirst(findSelectedObject(preSelectedList[0]) || defaults[0])
      setSecond(findSelectedObject(preSelectedList[1]) || defaults[1])
      onChange({
        first: findSelectedObject(preSelectedList[0]) || defaults[0],
        second: findSelectedObject(preSelectedList[1]) || defaults[1],
      })
    } else if (defaults) {
      setFirst(defaults[0])
      setSecond(defaults[1])
      onChange({ first: defaults[0], second: defaults[1] })
    }
  }, [list, defaults, searchParams])

  const findSelectedObject = selectedKey => {
    let obj
    list.some(item => {
      obj = item.children.find(obj => obj?.key == selectedKey)
      return !!obj
    })
    return obj
  }

  const onSelectFirst = ({ key }) => {
    const selectedObject = list?.map(e => e?.children?.find(e => e?.key === key)).find(e => e !== undefined)
    setFirst(selectedObject)
    onChange({ second, first: selectedObject })
    setSearchParams({ ...queryObj, compare: `${selectedObject?.key}-vs-${second?.key}` })
    fireEvent({ ...ACTION_TYPES.compare_metrics, ...from })
  }

  const onSelectSecond = ({ key }) => {
    const selectedObject = list?.map(e => e?.children?.find(e => e?.key === key))?.find(e => e !== undefined)
    setSecond(selectedObject)
    onChange({ first, second: selectedObject })
    setSearchParams({ ...queryObj, compare: `${first?.key}-vs-${selectedObject?.key}` })
    fireEvent({ ...ACTION_TYPES.compare_metrics, ...from })
  }

  const firstList = useMemo(
    () =>
      list.map(e => ({
        ...e,
        type: "group",
        children: e.children.map(e => ({
          ...e,
          icon: <Icon icon="VscCircleFilled" color={theme["error-color"]} />,
          disabled: e?.key === second?.key,
        })),
      })),
    [second]
  )
  const secondList = useMemo(
    () =>
      list.map(e => ({
        ...e,
        type: "group",
        children: e?.children?.map(e => ({
          ...e,
          icon: <Icon icon="VscCircleFilled" color={theme["link-hover"]} />,
          disabled: e?.key === first?.key,
        })),
      })),
    [first]
  )

  return loading ? (
    <Skeleton />
  ) : (
    <Space className={styles.comparisonCtrls}>
      <IconText icon="MdFlip" title={t("Compare")} textType="secondary" style={{ marginInlineEnd: 8 }} />
      <Dropdown
        menu={{
          items: firstList,
          onSelect: onSelectFirst,
          selectable: true,
          style: menuStyle,
          selectedKeys: first?.key,
        }}
        disabled={disabled}
      >
        <IconText
          icon="VscCircleFilled"
          iconProps={{ color: theme["error-color"], style: { transform: "translateY(1px)" } }}
          title={first?.label}
        />
      </Dropdown>
      <Text type="secondary">{t("Vs")}</Text>
      <Dropdown
        menu={{
          items: secondList,
          onSelect: onSelectSecond,
          selectable: true,
          style: menuStyle,
          selectedKeys: second?.key,
        }}
        disabled={disabled}
      >
        <IconText
          icon="VscCircleFilled"
          iconProps={{ color: theme["link-hover"], style: { transform: "translateY(1px)" } }}
          title={second?.label}
        />
      </Dropdown>
    </Space>
  )
}

export default CommonListDropdown
